import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group";
import { cn } from "../../@/lib/utils";
const ToggleGroup = React.forwardRef(({ className, ...props }, ref) => {
    return (_jsx(ToggleGroupPrimitive.Root, { className: cn("flex gap-2", className), ...props, ref: ref }));
});
ToggleGroup.displayName = ToggleGroupPrimitive.Root.displayName;
const ToggleGroupItem = React.forwardRef(({ className, children, ...props }, ref) => {
    return (_jsx(ToggleGroupPrimitive.Item, { ref: ref, className: cn("flex items-center justify-center rounded-full text-md font-bold bg-blue-200 text-blue-500 py-2 px-6 ring-offset-background transition-colors hover:bg-yellow-500 hover:text-blue-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-yellow-500", className), ...props, children: children }));
});
ToggleGroupItem.displayName = ToggleGroupPrimitive.Item.displayName;
export { ToggleGroupItem, ToggleGroup };
//# sourceMappingURL=ToggleGroup.js.map